module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root .Socket":{"path":[{"value":"","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"@root .Socket","_fox_":1}]},"@root":{"handleWom.exoRun.event":[{"value":"running","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"@root","_fox_":1}],"handleWom.exoRun.widget":[{"value":"@root","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"@root","_fox_":1}],"handleWom.exoRun.callback":[{"value":function () {
require('services/exodentity')(fox);
fox.exodentity.include();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101011},"path":"@root","_fox_":1}],"widgets.googleAnalytics.hooks.onStartInit":[{"value":function() {
var data;
if (typeof fox.Consent != 'undefined' && typeof fox.Consent.getSettings == 'function') {
data = !!fox.Consent.getSettings()['cookiesPerformance'];
} else {
data = true
}
this.setOption('optOut', !data);
if(!data) {
this.setOption('cookieDomain', {storage: 'none'});
this.rwom1('@root').setOption('gaCodes', false);
fox.Consent.removeCookies('cookiesPerformance');
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101026},"path":"@root","_fox_":1}],"widgets.hotjar.hooks.onStartInit":[{"value":function() {
var data;
if (typeof fox.Consent != 'undefined' && typeof fox.Consent.getSettings == 'function') {
data = !!fox.Consent.getSettings()['cookiesPerformance'];
} else {
data = true
}
this.setOption('optOut', !data);
if(!data) {
fox.Consent.removeCookies('cookiesPerformance');
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101040},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/options/commonApp.js
// module id = 405
// module chunks = 2